module.exports = __webpack_public_path__ + "static/jaafar-6de1c7236dbdce502db20872b043b61e.jpg";